import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=65e97abd&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=65e97abd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e97abd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e97abd')) {
      api.createRecord('65e97abd', component.options)
    } else {
      api.reload('65e97abd', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=65e97abd&scoped=true&", function () {
      api.rerender('65e97abd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cdfWpux2afFE/JS/comp/PopupBox.vue"
export default component.exports